
import { defineComponent, PropType } from 'vue'

import RunDetailMixin from '~/mixins/runDetailMixin'

import { checkArrayEquality } from '~/utils/array'
import { safeRenderBackticks } from '~/utils/string'

export interface RunError {
  level: number
  message: string
}

/**
 * Bar to show autofix counts and button to trigger it
 */
export default defineComponent({
  name: 'RunAutofixModal',
  props: {
    autofixableIssues: {
      type: Array as PropType<Array<Record<string, string>>>,
      default: []
    },
    canCreateAutofix: {
      type: Boolean,
      default: true
    },
    filesAffectedByAutofix: {
      type: Number,
      default: 0
    },
    autofixLoading: {
      type: Boolean,
      default: false
    }
  },
  mixins: [RunDetailMixin],
  data() {
    return {
      isAccordionOpen: false,
      selectedIssues: [] as Array<string>,
      selectAll: true
    }
  },
  mounted() {
    this.selectedIssues = this.selectAll
      ? this.autofixableIssues.map((issue) => issue.shortcode)
      : []
  },
  watch: {
    autofixLoading: {
      handler(): void {
        this.closeAccordion()
      }
    },
    selectedIssues: {
      handler(updatedSelectedIssues: Array<string>): void {
        this.toggleSelectAll(updatedSelectedIssues)
      }
    }
  },
  methods: {
    safeRenderBackticks,
    updateSelectAll(newVal: boolean): void {
      this.selectedIssues = newVal ? this.autofixableIssues.map((issue) => issue.shortcode) : []
    },
    closeAccordion(): void {
      if (this.autofixLoading === false) this.isAccordionOpen = false
    },
    toggleSelectAll(updatedSelectedIssues: Array<string>): void {
      const autofixableIssueShortcodes = this.autofixableIssues.map((issue) => issue.shortcode)

      this.selectAll = checkArrayEquality(autofixableIssueShortcodes, updatedSelectedIssues)
    },
    triggerAutofixOnSelectedIssues(close?: () => void): void {
      this.$emit('autofixIssues', this.selectedIssues, close)
    }
  }
})
